<div>
  <section class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1><i class="fas fa-building"></i> Tenant Manager</h1>
        </div>
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item">
              <a routerLink="/tenant/index">
                <i class="fas fa-building"></i> Tenant Manager
              </a>
            </li>
            <li class="breadcrumb-item active">
              <b>User Manager</b>
            </li>
          </ol>
        </div>
      </div>
    </div>
  </section>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-4">
          <div class="card">
            <div class="overlay" *ngIf="scope.wait">
              <i class="fas fa-spinner fa-spin"></i>
            </div>
            <div class="card-body card-profile">
              <div class="row">
                <div class="col-12 p-0">
                  <h3 class="profile-username">
                    {{ scope.tenant.tenantName }}
                  </h3>  
                  <p class="text-muted tenant_cd">
                    {{ scope.tenant.tenantCd  }}
                  </p>  
                </div>
              </div>
            <ul class="list-group list-group-unbordered">
                <li class="list-group-item">
                  <div class="item-header float-left">Address</div>
                  <div class="item float-right">
                    {{ scope.tenant.address }}
                  </div>
                  <!-- <div class="item pull-right">
                    <mat-form-field class="full-width">
                      <input matInput placeholder="テナント名"  formControlName="tenantName">
                      <mat-icon matSuffix>business</mat-icon>
                    </mat-form-field>
                  </div> -->
                </li>
                <li class="list-group-item">
                  <div class="item-header float-left">TEL</div>
                  <div class="item float-right">
                    {{ scope.tenant.tel }}
                  </div>
                </li>
                <li class="list-group-item">
                  <div class="item-header float-left">Adminitrator</div>
                  <div class="item float-right">
                    {{ scope.tenant.mainFamilyName }} {{ scope.tenant.mainFirstName }} 
                  </div>
                </li>
                <li class="list-group-item">
                  <div class="item-header float-left">Post</div>
                  <div class="item float-right">
                    {{ scope.tenant.mainPosition }}
                  </div>
                </li>
                <li class="list-group-item">
                  <div class="item-header float-left">E Mail</div>
                  <div class="float-right">
                    {{ scope.tenant.mainEmail }}
                  </div>
                </li>
              </ul>
              <div class="text-center full-width margin-top-10px">
                <button class="full-width " mat-raised-button color="warn" (click)="editTenant()">テナント情報を編集</button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-8 table-area">
          <div class="card card">
            <div class="overlay" *ngIf="scope.wait">
              <i class="fas fa-spinner fa-spin"></i>
            </div>

            <div class="card-header with-border">
              <h3 class="card-title">ユーザ一覧</h3>
              <div class="float-right">
                <button mat-raised-button color="warn" (click)="entryUser()">登録</button>
              </div>
            </div>
            <div class="card-body">
              <table mat-table matSort [dataSource]="dataSource" class="table table-bordered">
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                <ng-container matColumnDef="email">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>E Mail</th>
                  <td mat-cell *matCellDef="let element">
                    {{element.email}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                  <td mat-cell *matCellDef="let element">
                    {{element.name}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="position">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Post</th>
                  <td mat-cell *matCellDef="let element">
                    {{element.position}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="loginStatusCd">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                  <td mat-cell *matCellDef="let element">
                    <span *ngIf="element.loginStatusCd==0">0:使用中</span>
                    <span *ngIf="element.loginStatusCd==9">9:未使用</span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element" class="text-center actions">
                    <tr>
                      <button mat-raised-button (click)="editUser(element)" style="margin: 5px">編集</button>
                      <button mat-stroked-button (click)="deleteUser(element)" color="warn" style="margin: 5px">削除</button>
                    </tr>
                  </td>
                </ng-container> 
              </table>  
            </div>
            <div class="box-footer clearfix">
              <mat-paginator [length]="100"
                [pageSize]="10"
                [pageSizeOptions]="[5, 10, 25, 100]" showFirstLastButtons>
              </mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
